/**
 * Is this tenant's data a demonstration rather than a record of a response?
 *
 * PAIRED with the `is_demonstration` gate in
 * services/voice-worker/scripts/render_incident_report.py and
 * tasks/draft_report.py — `plan_tier == "sandbox" or environment_class != "real"`.
 * Change one, change the other.
 *
 * This exists because the banner was PDF-only. A prospect on a sandbox tenant
 * who opened a report in the browser and hit Print got a page with a real
 * letterhead, real-looking exposure figures and nothing saying it was
 * synthetic — the document-integrity failure the PDF banner exists to prevent,
 * reached by the likelier route, since a prospect is far more apt to print
 * what is on screen than to go and find the generated PDF.
 *
 * Unknown defaults to NOT a demonstration: the banner is a claim about the
 * document, and stamping "synthetic" across a real department's filed record
 * because /auth/me was slow to load would be its own integrity failure. The
 * PDF path is the authority for the filed artifact; this is belt-and-braces on
 * the screen copy.
 */
export function isDemonstrationTenant(department?: {
  plan_tier?: string | null;
  environment_class?: string | null;
} | null): boolean {
  if (!department) return false;
  if (department.plan_tier === "sandbox") return true;
  // Absent means unknown, not "real" — but an unknown environment_class on a
  // non-sandbox tier is the normal shape for every real tenant, so it must not
  // trip the banner on its own.
  return (
    department.environment_class != null && department.environment_class !== "real"
  );
}
